import { memo } from "react";
import YearPicker from "./YearPicker";
import MonthPicker from "./MonthPicker";

function DashboardPeriodFilters({
  viewType,
  onViewTypeChange,
  year,
  onYearChange,
  month,
  onMonthChange,
}) {
  return (
    <div className="dash-period-toolbar">
      <span className="dash-period-toolbar__label">View by</span>
      <div className="dash-period-toolbar__controls">
        <div className="dash-chart-view-toggle" role="group" aria-label="Dashboard period">
          <button
            type="button"
            className={`dash-chart-view-toggle__btn${viewType === "yearly" ? " is-active" : ""}`}
            onClick={() => onViewTypeChange("yearly")}
          >
            Yearly
          </button>
          <button
            type="button"
            className={`dash-chart-view-toggle__btn${viewType === "monthly" ? " is-active" : ""}`}
            onClick={() => onViewTypeChange("monthly")}
          >
            Monthly
          </button>
        </div>
        <div className="dash-date-pickers">
          {viewType === "monthly" && (
            <MonthPicker value={month} year={year} onChange={onMonthChange} />
          )}
          <YearPicker
            value={year}
            onChange={(nextYear) => {
              onYearChange(nextYear);
              const currentYear = new Date().getFullYear();
              const currentMonth = new Date().getMonth() + 1;
              if (Number(nextYear) === currentYear && Number(month) > currentMonth) {
                onMonthChange(String(currentMonth));
              }
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default memo(DashboardPeriodFilters);
